"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
const computePrice_1 = require("../computePrice");
/**
 * Updates the source order with transferred status and transfer info
 * @param event - The event containing transfer details
 * @param prevState - The previous state of the order
 * @returns The updated order
 */
function default_1(event, prevState = {}) {
    var _a, _b;
    const order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status) ||
        !(0, utils_1.canPerformTransfer)((_a = event.transferredItemsFrom) === null || _a === void 0 ? void 0 : _a.tableId, (_b = event.transferredItemsTo) === null || _b === void 0 ? void 0 : _b.tableId)) {
        return order;
    }
    const transferredItemIds = new Set(event.transferredItemsFrom.orderItems.map(item => item.id));
    order.orderItems.forEach(item => {
        var _a, _b;
        if (transferredItemIds.has(item.id)) {
            item.status = domain_1.OrderItemStatus.TRANSFERRED;
            item.transferInfo = {
                toTableId: (_a = event.transferredItemsTo) === null || _a === void 0 ? void 0 : _a.tableId,
                toOrderId: event.transferredItemsTo.orderId,
                fromOrderId: event.transferredItemsFrom.orderId,
                fromTableId: (_b = event.transferredItemsFrom) === null || _b === void 0 ? void 0 : _b.tableId,
                transferredAt: event.timestamp,
                transferredBy: {
                    id: event.triggeredBy,
                    name: event.transferredByName,
                },
            };
        }
    });
    return {
        ...order,
        ...(0, computePrice_1.computeOrderTotals)(order),
    };
}
exports.default = default_1;
//# sourceMappingURL=transferredItems.js.map